// eslint-disable-next-line import/prefer-default-export
export const CHECKLIST_TYPE = {
  ANALYTICAL: 'ANALYTICAL',
  SYNTHETIC: 'SYNTHETIC',
};
